import {
  CSSProperties,
  DetailedHTMLProps,
  HTMLAttributes,
  ReactNode,
} from 'react'
import cx from 'classnames'

type PropsAddedByRcTooltip = Pick<
  DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
  'onMouseEnter' | 'onMouseLeave' | 'onFocus' | 'onClick'
> // needed for Tooltip: https://github.com/react-component/tooltip#important-note

type Props = {
  children: ReactNode
  className?: string
  style?: CSSProperties // TODO can we remove this?
  wordBreak?: 'words' | 'all'
  isCustomCell?: boolean
} & PropsAddedByRcTooltip

const Base = ({
  children,
  className,
  onMouseEnter,
  onMouseLeave,
  onFocus,
  onClick,
  wordBreak = 'words',
  isCustomCell = false,
}: Props) => {
  return (
    <div
      className={cx('flex items-center px-4', className, {
        'break-all': wordBreak === 'all',
        'break-words': wordBreak === 'words',
        'child-cell': !isCustomCell,
      })}
      // props added by rc-tooltip
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onFocus={onFocus}
      onClick={onClick}
    >
      {children}
    </div>
  )
}

export default Base
